import React from 'react';
import { CardActions, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Container, PageHeader, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { Button, Typography, Divider, Card, CardContent } from '@occc/ui-design-system';

import { breadcrumbLinks } from './constants';

import { FormContent } from '../components/FormContent';
import { DisplayCategoryFormRenderProps } from '../types';

export interface CreateDisplayCategoryFormRenderComponentProps
  extends Pick<DisplayCategoryFormRenderProps, 'handleSubmit'> {
  disabled: boolean;
}

export const CreateDisplayCategoryFormRenderComponent: React.FC<
  CreateDisplayCategoryFormRenderComponentProps
> = ({ handleSubmit, disabled }) => {
  const navigate = useNavigate();

  useAppLayoutContextConsumer(breadcrumbLinks);

  // TODO: move Container and PageHeader to level up and replace it along with Helmet by Page component
  return (
    <Container variant='md' includesPageHeader>
      <PageHeader
        title='Display Category'
        subtitle='Display Categories help you organize your Campaign components and the product preferences available to your members.'
      />
      <form onSubmit={handleSubmit}>
        <Card>
          <CardContent>
            <Box>
              <Typography variant='h6' gutterBottom>
                Create Display Category
              </Typography>
              <FormContent />
            </Box>
          </CardContent>
          <Divider />
          <CardActions>
            <Button onClick={() => navigate(-1)}>Cancel</Button>
            <Button variant='contained' color='primary' onClick={handleSubmit} disabled={disabled}>
              Create
            </Button>
          </CardActions>
        </Card>
      </form>
    </Container>
  );
};
